var exports = {
  "p_": "list__80ev8A",
  "nM": "row__acGJ4F",
  "my": "avatar__geHtz2",
  "UU": "name__Hd7vNa",
  "q3": "indicator__jscG_q",
};

module.exports = exports;
